import React, {useContext, useEffect, useState} from 'react';
import {Checkbox} from 'semantic-ui-react';
import {AppContext} from '../../context/app/appContext';

export const SettingsUserSettings = () => {
    const [peopleOpsFirstName, setPeopleOpsFirstName] = useState('');
    const [peopleOpsLastName, setPeopleOpsLastName] = useState('');
    const [peopleOpsContactNumber, setPeopleOpsContactNumber] = useState('');
    const [peopleOpsContactEmail, setPeopleOpsContactEmail] = useState('');

    // const [addPerkBudgetApprover, setAddPerkBudgetApprover] = useState(false);
    const [perkBudgetApproverFirstName, setPerkBudgetApproverFirstName] = useState('');
    const [perkBudgetApproverLastName, setPerkBudgetApproverLastName] = useState('');
    const [perkBudgetApproverContactNumber, setPerkBudgetApproverContactNumber] = useState('');
    const [perkBudgetApproverContactEmail, setPerkBudgetApproverContactEmail] = useState('');

    const appContext = useContext(AppContext);
    const organization = appContext.organization;

    useEffect(() => {
        setPeopleOpsFirstName(organization.peopleOpsContact &&
            organization.peopleOpsContact.firstName);
        setPeopleOpsLastName(organization.peopleOpsContact &&
            organization.peopleOpsContact.lastName);
        setPeopleOpsContactNumber(organization.peopleOpsContact &&
            organization.peopleOpsContact.contactNumber);
        setPeopleOpsContactEmail(
            organization.peopleOpsContact && organization.peopleOpsContact.email);

        setPerkBudgetApproverFirstName(
            organization.perkBudgetApproverContact &&
            organization.perkBudgetApproverContact.firstName);
        setPerkBudgetApproverLastName(
            organization.perkBudgetApproverContact &&
            organization.perkBudgetApproverContact.lastName);
        setPerkBudgetApproverContactNumber(
            organization.perkBudgetApproverContact &&
            organization.perkBudgetApproverContact.phoneNumber);
        setPerkBudgetApproverContactEmail(
            organization.perkBudgetApproverContact &&
            organization.perkBudgetApproverContact.email);
    }, [organization]);

    const onContactsUpdateFormSubmit = async (event) => {
        event.preventDefault();
        await appContext.updateOrganization({
        peopleOpsContact: {
            firstName: peopleOpsFirstName,
            lastName: peopleOpsLastName,
            phoneNumber: peopleOpsContactNumber,
            email: peopleOpsContactEmail,
        },
        perkBudgetApproverContact: {
            firstName: perkBudgetApproverFirstName,
            lastName: perkBudgetApproverLastName,
            phoneNumber: perkBudgetApproverContactNumber,
            email: perkBudgetApproverContactEmail,
        },
        });
    };

    return (
        <div className='dashboard-page'>
            <div className="ui grid">

            <div className="ui row">
                <div className="ui column">
                <div className="ui segment">
                    <h3>My Profile</h3>
                    <div className="grid ui">
                    <div className="two wide column">
                        <img
                            src="https://react.semantic-ui.com/images/wireframe/square-image.png"
                            className="ui small image" alt="George Fields"/>
                    </div>

                    <div className="thirteen wide column">
                        <a href="#top"
                        className="ui button change-password">change
                        password</a>
                        <div className="ui divider"/>
                        <a href="#top" className="ui button upload-id">upload ID</a>
                        <h5>Please upload a copy of your state issued ID for
                        a one-time verification. Your data us not stored
                        and is only used for verification.</h5>
                    </div>
                    </div>
                </div>
                </div>
            </div>

            <div className="ui row">
                <div className="column">

                <form className="ui form" onSubmit={onContactsUpdateFormSubmit}>

                    <div className="ui segment">
                    <h3>People Ops Contact</h3>
                    <p>Resource who will actively manage or over see
                        the perk program (HR/People Ops/Team
                        lead)</p>

                    <div className="inline fields">

                        <div className="field two wide">
                        <label>Name</label>
                        </div>

                        <div className="field four wide">
                        <input type="text"
                                placeholder="First Name"
                                onChange={e => setPeopleOpsFirstName(
                                    e.target.value)}
                                value={peopleOpsFirstName}/>
                        </div>

                        <div className="field four wide">
                        <input type="text"
                                placeholder="Last Name"
                                onChange={e => setPeopleOpsLastName(
                                    e.target.value)}
                                value={peopleOpsLastName}/>
                        </div>

                    </div>

                    <div className="inline fields">
                        <div className="field two wide">
                        <label>Contact Number</label>
                        </div>
                        <div className="field eight wide">
                        <input type="text"
                                onChange={e => setPeopleOpsContactNumber(
                                    e.target.value)}
                                value={peopleOpsContactNumber}/>
                        </div>
                    </div>

                    <div className="inline fields">
                        <div className="field two wide">
                        <label>Contact Email</label>
                        </div>
                        <div className="field eight wide">
                        <input type="text"
                                onChange={e => setPeopleOpsContactEmail(
                                    e.target.value)}
                                value={peopleOpsContactEmail}/>
                        </div>
                    </div>
                    </div>

                    <div className="ui segment">
                    <div className="field fluid">
                        <Checkbox label="Add perk budget approver (This contact's email can be used to
                        request perk budget approval)"/>
                    </div>

                    <div className="inline fields">

                        <div className="field two wide">
                        <label>Name</label>
                        </div>

                        <div className="field four wide">
                        <input type="text"
                                placeholder="First Name"
                                onChange={e => setPerkBudgetApproverFirstName(
                                    e.target.value)}
                                value={perkBudgetApproverFirstName}/>
                        </div>

                        <div className="field four wide">
                        <input type="text"
                                placeholder="Last Name"
                                onChange={e => setPerkBudgetApproverLastName(
                                    e.target.value)}
                                value={perkBudgetApproverLastName}/>
                        </div>

                    </div>

                    <div className="inline fields">
                        <div className="field two wide">
                        <label>Contact Number</label>
                        </div>
                        <div className="field eight wide">
                        <input type="text"
                                onChange={e => setPerkBudgetApproverContactNumber(
                                    e.target.value)}
                                value={perkBudgetApproverContactNumber}/>
                        </div>
                    </div>

                    <div className="inline fields">
                        <div className="field two wide">
                        <label>Contact Email</label>
                        </div>
                        <div className="field eight wide">
                        <input type="text"
                                onChange={e => setPerkBudgetApproverContactEmail(
                                    e.target.value)}
                                value={perkBudgetApproverContactEmail}/>
                        </div>
                    </div>
                    </div>

                    <footer>
                    <button className="ui button">Save</button>
                    <button className="ui button">Cancel</button>
                    </footer>
                </form>
                </div>
            </div>

            </div>
        </div>
    );
}